import React, { Component } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'

import SoftPullForm from './softPullForm'
import { createRefi } from '../refiActions'
import { selectCurrentRefiApplication } from '../../../reducers'
import { scrollToHeader } from '../../../helpers/displayFormatHelper'
import { RefiApp } from '../types'
import { iso8601DateFormat } from '../../../helpers/timeHelper'

export type Callback<T = void> = (...args: any) => T

interface LocalState {
  showCoApplicantForm: boolean
}

export function formatSoftPullFormData(values, refiApp, showCoApplicantForm) {
  const {
    birthdate,
    employmentStartDate,
    monthlyHousingExpense,
    startDate,
    ssn,
    statedAnnualIncome,
    coappBirthdate,
    coappCity,
    coappEmail,
    coappEmploymentStartDate,
    coappFirstName,
    coappLastName,
    coappLine1,
    coappLine2,
    coappMonthlyHousingExpense,
    coappPhone,
    coappSsn,
    coappStartDate,
    coappState,
    coappStatedAnnualIncome,
    coappZip,
    generateEmail,
  } = values

  const coappCurrentAddress = {
    line1: coappLine1,
    line2: coappLine2,
    city: coappCity,
    state: coappState,
    zip: coappZip,
    startDate: iso8601DateFormat(coappStartDate),
  }
  const { userId, vehicleId } = refiApp
  const applicant = {
    userId,
    birthdate: iso8601DateFormat(birthdate),
    employmentStartDate: iso8601DateFormat(employmentStartDate),
    monthlyHousingExpense: numeral(monthlyHousingExpense).value(),
    startDate: iso8601DateFormat(startDate),
    ssn: ssn.replace(/-/g, ''),
    statedAnnualIncome: numeral(statedAnnualIncome).value(),
  }

  if (showCoApplicantForm) {
    const coApplicant = {
      firstName: coappFirstName,
      lastName: coappLastName,
      phone: coappPhone,
      email: coappEmail,
      generateEmail,
      birthdate: iso8601DateFormat(coappBirthdate),
      employmentStartDate: iso8601DateFormat(coappEmploymentStartDate),
      monthlyHousingExpense: numeral(coappMonthlyHousingExpense).value(),
      ssn: coappSsn.replace(/-/g, ''),
      statedAnnualIncome: numeral(coappStatedAnnualIncome).value(),
      currentAddress: coappCurrentAddress,
    }

    return {
      applicant,
      coApplicant,
      vehicleId,
    }
  }

  return {
    applicant,
    vehicleId,
  }
}

export interface Props {
  createRefi: Callback<Promise<any>>
  refiApp: RefiApp
}

export class SoftPull extends Component<Props, LocalState> {
  static displayName = 'SoftPull'
  constructor(props: Props) {
    super(props)
    this.state = {
      showCoApplicantForm: false,
    }
  }

  toggleShowCoApplicantForm = () => {
    const { showCoApplicantForm } = this.state
    this.setState({ showCoApplicantForm: !showCoApplicantForm })
  }

  onSubmit = (values) => {
    const { createRefi, refiApp } = this.props
    const showCoApplicantForm = this.state.showCoApplicantForm
    return createRefi(
      formatSoftPullFormData(values, refiApp, showCoApplicantForm)
    ).then(
      () => {},
      () => {
        scrollToHeader()
      }
    )
  }

  render() {
    const { showCoApplicantForm } = this.state
    return (
      <SoftPullForm
        onSubmit={this.onSubmit}
        showCoApplicantForm={showCoApplicantForm}
        toggleShowCoApplicantForm={this.toggleShowCoApplicantForm}
      />
    )
  }
}

export const mapStateToProps = (state) => ({
  refiApp: selectCurrentRefiApplication(state),
})

export default connect(mapStateToProps, {
  createRefi,
})(SoftPull)
